import React, {ChangeEvent, ComponentProps, SyntheticEvent, useRef} from 'react';
import classNames from 'classnames';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from '../ButtonUploadExcel/styles.module.scss';

interface ButtonUploadFileProps extends ComponentProps<'input'> {
  onFileSelected: (file: File) => void;
  containerClassnames?: string;
  loading?: boolean;
}

export const ButtonUploadFile = ({onFileSelected, containerClassnames, loading, ...rest}: ButtonUploadFileProps) => {
  const elementRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (elementRef.current) {
      const [file] = Array.from(elementRef.current.files || []);
      onFileSelected(file);
    }
  };

  const handleClick = (e: SyntheticEvent) => {
    if (elementRef.current) {
      elementRef.current.value = '';
    }
  };

  return (
    <label className={classNames(
      styles.buttonUpload,
      'btn btn-sm p-0 mb-0',
      rest.disabled ? 'opacity-30' : '',
      containerClassnames
    )}>
      {loading
        ?
        <div className="spinner-border spinner-border-sm text-light" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        :
        <img
          src={toAbsoluteUrl('/media/svg/Uploaded-file_white.svg')}
          alt="upload-file"
          height={24}
        />
      }
      <input
        ref={elementRef}
        type="file"
        className="d-none"
        onChange={handleChange}
        onClick={handleClick}
        multiple
        {...rest}
      />
    </label>
  );
};

